import { AnalyticsEvent } from '../services/analytics/analytics.contract';
import { analyticsEventService } from '../services/analytics/analytics-event.service';
import { DirectiveBinding } from 'vue/types/options';

interface AnalyticsBinding extends DirectiveBinding {
  value?: AnalyticsEvent;
}

const trackClickEvent = (element: HTMLElement, binding: AnalyticsBinding) => {
  // eslint-disable-next-line
  const { name, category, label } = binding.value!;
  // use mousedown in stead of click because buttons fire two click events which causes this event to trigger twice on click
  element.addEventListener('mousedown', () => analyticsEventService.trackEvent(name, category, label || ''));
};

export default trackClickEvent;
